import React, { useEffect, useState } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const IconsDisplay = () => {
  const [requisitionCount, setRequisitionCount] = useState(0);
  const [surrenderCount, setSurrenderCount] = useState(0);

  const iconStyle = {
    width: "150px",
    height: "150px",
    margin: "20px",
  };

  const containerStyle = {
    display: "flex",
    gap: "40px",
    padding: "20px",
  };

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) {
          console.error("User not logged in");
          return;
        }
  
        const [reqRes, surRes] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Requisition/user/count/${userId}`
          ),
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Surrender/user/count/${userId}`
          ),
        ]);
  
        setRequisitionCount(reqRes.data);
        setSurrenderCount(surRes.data);
      } catch (err) {
        console.error("Failed to fetch counts", err);
      }
    };
  
    fetchCounts();
  }, []);
  
  

  return (
    <div style={containerStyle}>
      {/* Requisitions Icon */}
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          style={iconStyle}
          fill="blue"
        >
          <rect width="48" height="60" x="8" y="2" rx="4" ry="4" fill="#e3e3e3" />
          <path d="M16 12h32v4H16zM16 22h32v4H16zM16 32h32v4H16z" fill="#555" />
        </svg>
        <p style={{ textAlign: "center" }}>Requisition Submissions:</p>
        <p style={{ textAlign: "center", fontWeight: "bold" }}>
          {requisitionCount}
        </p>
      </div>

      {/* Surrenders Icon */}
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          style={iconStyle}
          fill="green"
        >
          <path
            d="M32 2l18 18H38v30H26V20H14z"
            fill="#c3f9d8"
          />
          <path d="M30 26h4v10h-4z" fill="#555" />
        </svg>
        <p style={{ textAlign: "center" }}>Surrender Submissions:</p>
        <p style={{ textAlign: "center", fontWeight: "bold" }}>
          {surrenderCount}
        </p>
      </div>

      {/* Graph Icon */}
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          style={iconStyle}
          fill="orange"
        >
          <rect x="10" y="34" width="8" height="20" fill="#fab387" />
          <rect x="26" y="22" width="8" height="32" fill="#f97316" />
          <rect x="42" y="14" width="8" height="40" fill="#fb923c" />
          <path d="M2 56h60v4H2z" fill="#555" />
        </svg>
        <p style={{ textAlign: "center" }}> </p>
      </div>
    </div>
  );
};

export default IconsDisplay;
